import { useEffect, useState } from 'react';
import type { ObjectiveListItem } from '@ddp/shared';

import { apiFetch } from '../../api/client.js';

/**
 * Liste des projets de l'organisation avec leur objectif et leurs signaux (ADR-0028), pour la section
 * Objectifs de la page Model. Le plan se dérive au rendu ; un rôle sans accès tombe en liste vide.
 */
export function useObjectivesList() {
  const [items, setItems] = useState<ObjectiveListItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    apiFetch<ObjectiveListItem[]>('/objectives')
      .then((list) => {
        if (active) setItems(list);
      })
      .catch(() => {
        // Pas d'accès ou aucun projet : on laisse la liste vide, sans écran d'erreur.
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { items, loading };
}
